import React from 'react';
import { RouteObject } from 'react-router-dom';
import { dossiersBasePath } from '@europrocurement/l2d-modules';
import { listeDossiersPath, detailDossierPath } from './constants';
import { DetailDossier, DossierRoot, ListeDossiers } from './views';

export const DossierRouter: RouteObject = {
    path: dossiersBasePath,
    element: <DossierRoot />,
    children: [
        {
            path: listeDossiersPath,
            element: <ListeDossiers />,
        },
        {
            path: detailDossierPath,
            element: <DetailDossier />,
        },
    ],
};
